// AUTHENTICATION URLS
export const LOGIN_URL = "/api/auth/login";
export const REGISTER_URL = "/api/auth/register";
export const FORGOT_PASSWORD_URL = "/api/auth/forgot-password";
export const GET_CAPTCHA_URL = "/api/auth/captcha";
export const SEND_CAPTCHA_URL = "/api/auth/captcha";
export const RE_CAPTCHA_URL = "/api/auth/reCaptcha";
export const VERIFY_CAPTCHA_URL = "/api/auth/verifyCaptcha";
export const CHANGE_PASSWORD_URL = "/api/auth/password";
export const CHANGE_EMAIL_URL = "/api/auth/email";
export const MFA_SETUP_URL = "/api/auth/mfa/setup";
export const MFA_ENABLE_URL = "/api/auth/mfa/enable";
export const MFA_DISABLE_URL = "/api/auth/mfa/disable";
export const DELETE_ACCOUNT_URL = "/api/auth/account";

// COMMENT URLS
export const CREATE_COMMENT_URL = (postId) => `/api/posts/${postId}/comments`;
export const DELETE_COMMENT_URL = (postId, commentId) =>
  `/api/posts/${postId}/comments/${commentId}`;
export const VOTE_COMMENT_URL = (postId, commentId) =>
  `/api/posts/${postId}/comments/${commentId}/reactions`;
export const CREATE_COMMENT_REPLY_URL = (postId, parentCommentId) =>
  `/api/posts/${postId}/comments/${parentCommentId}/replies`;
export const DELETE_COMMENT_REPLY_URL = (postId, commentReplyId) =>
  `/api/posts/${postId}/comments/${commentReplyId}`;
export const VOTE_COMMENT_REPLY_URL = (postId, commentReplyId) =>
  `/api/posts/${postId}/comments/${commentReplyId}/reactions`;
export const GET_COMMENT_REPLIES_URL = (postId, parentCommentId, offset, limit = 3) =>
  `/api/posts/${postId}/comments/${parentCommentId}/replies?offset=${offset || 0}&limit=${limit}`;
export const GET_COMMENTS_URL = (postId, offset, exclude) =>
  `/api/posts/${postId}/comments?offset=${offset || 0}&limit=10`;

// FEED URLS
export const GET_FEED_POSTS_URL = (offset) => `/api/posts/feed/${offset}`;

// NOTIFICATION URLS
export const GET_NOTIFICATIONS_URL = (cursor, take) => {
  const params = new URLSearchParams();
  if (cursor) params.append("cursor", cursor);
  if (take) params.append("take", take);
  const query = params.toString();
  return `/api/notifications${query ? `?${query}` : ""}`;
};
export const MARK_NOTIFICATION_READ_URL = (notificationId) =>
  `/api/notifications/${notificationId}/read`;
export const MARK_NOTIFICATIONS_READ_URL = "/api/notifications/read";
export const MARK_NOTIFICATIONS_SEEN_URL = "/api/notifications/seen";

// POST URLS
export const GET_POST_URL = (postId) => `/api/posts/${postId}`;
export const GET_POSTS_URL = (username, offset) =>
  `/api/user/${username}/posts/${offset}`;
export const VOTE_POST_URL = (postId) => `/api/posts/${postId}/reactions`;
export const CREATE_POST_URL = "/api/posts";
export const DELETE_POST_URL = (postId) => `/api/posts/${postId}`;
export const BOOKMARK_POST_URL = (postId) => `/api/user/${postId}/bookmark`;
export const GET_POST_FILTERS_URL = "/api/posts/filters";
export const GET_SUGGESTED_POSTS_URL = (offset) =>
  `/api/posts/suggested/${offset}`;
export const GET_HASHTAG_POSTS_URL = (hashtag, offset) =>
  `/api/posts/hashtag/${hashtag}/${offset}`;

// MONETIZATION URLS
export const MONETIZATION_CREATOR_PROFILE_URL = "/api/monetization/creator/profile";
export const MONETIZATION_CREATOR_TIERS_URL = "/api/monetization/creator/tiers";
export const MONETIZATION_CREATOR_STATS_URL = "/api/monetization/creator/stats";
export const MONETIZATION_PUBLIC_PROFILE_URL = (username) =>
  `/api/monetization/creators/${username}/profile`;
export const MONETIZATION_PUBLIC_TIERS_URL = (username) =>
  `/api/monetization/creators/${username}/tiers`;
export const MONETIZATION_SUBSCRIPTIONS_URL = "/api/monetization/subscriptions";
export const MONETIZATION_SUBSCRIPTION_ID_URL = (subscriptionId) =>
  `/api/monetization/subscriptions/${subscriptionId}`;
export const MONETIZATION_OVERVIEW_URL = "/api/monetization/me/overview";
export const MONETIZATION_POST_PURCHASE_URL = (postId) =>
  `/api/monetization/posts/${postId}/purchase`;

// PROFILE URLS
export const GET_USER_PROFILE_URL = (username) => `/api/profiles/${username}`;
export const FOLLOW_USER_URL = (username) => `/api/profiles/${username}/follow`;
export const GET_USER_FOLLOWING_URL = (username) =>
  `/api/profiles/${username}/following`;
export const GET_USER_FOLLOWERS_URL = (username) =>
  `/api/profiles/${username}/followers`;

// USER URLS
export const SEARCH_USERS_URL = (username, offset) =>
  `/api/user/${username}/${offset}/search`;
export const CONFIRM_USER_URL = "/api/user/confirm";
export const VERIFY_EMAIL_URL = "/api/auth/verifyEmail";
export const CHANGE_AVATAR_URL = "/api/profiles/avatar";
export const REMOVE_AVATAR_URL = "/api/user/avatar";
export const UPDATE_PROFILE_URL = "/api/profiles/edit";
export const GET_SUGGESTED_USERS_URL = (max) =>
  `/api/user/suggested/${max || ""}`;

// RECOMMENDATIONS URLS
export const GET_PEOPLE_RECOMMENDATIONS_URL = ({ limit, cursor } = {}) => {
  const params = new URLSearchParams();
  params.append("limit", limit || 20);
  if (cursor) {
    params.append("cursor", cursor);
  }
  const query = params.toString();
  return `/api/recommendations/people${query ? `?${query}` : ""}`;
};
export const POST_RECOMMENDATIONS_FEEDBACK_URL =
  "/api/recommendations/people/feedback";

// SUPER ADMIN URLS
export const SUPER_ADMIN_USERS_URL = "/api/super-admin/users";
export const SUPER_ADMIN_USER_URL = (userId) =>
  `/api/super-admin/users/${userId}`;
export const SUPER_ADMIN_IMPERSONATE_URL = (userId) =>
  `/api/super-admin/users/${userId}/impersonate`;
export const SUPER_ADMIN_SUSPEND_URL = (userId) =>
  `/api/super-admin/users/${userId}/suspend`;
export const SUPER_ADMIN_UNSUSPEND_URL = (userId) =>
  `/api/super-admin/users/${userId}/unsuspend`;
export const SUPER_ADMIN_HARD_DELETE_URL = (userId) =>
  `/api/super-admin/users/${userId}/hard`;
export const SUPER_ADMIN_UPDATE_ROLES_URL = (userId) =>
  `/api/super-admin/users/${userId}/roles`;
export const STOP_IMPERSONATION_URL = "/api/auth/stop-impersonation";
export const SUPER_ADMIN_TEST_DATA_URL = "/api/super-admin/test-data";
export const SUPER_ADMIN_LOGS_URL = "/api/super-admin/logs";
